/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {PartnersGroupedByCountryModel} from '../partners-grouped-by-country.model';
import {CountryDropdownOptionModel} from '../country-dropdown-option.model';
import {EntityGroupDetailDropdownOptionModel} from '../entity-group-detail-dropdown-option.model';
import {BaseChipSelectorZoneTooltipEnum} from '../../../../../shared/chip-selector/base-chip-selector-zone-tooltip.enum';
import {CodeFilterModel} from '../../../../../shared/filter/code-filter/code-filter.model';

export class PartnersGroupedByCountryMapper {
    private constructor() {
    }

    static toCountryDropdownOptionModelArray(input: PartnersGroupedByCountryModel[]): CountryDropdownOptionModel[] {
        return input?.map((group) => <CountryDropdownOptionModel>({
            value: group.country,
            children: PartnersGroupedByCountryMapper.toPartnerDropdownOptionModelArray(group),
            titleTransform(): string {
                return this.value.name;
            },
            tooltipType: BaseChipSelectorZoneTooltipEnum.DYNAMIC
        }));
    }

    static toPartnerDropdownOptionModelArray(input: PartnersGroupedByCountryModel): EntityGroupDetailDropdownOptionModel[] {
        return input?.partners.map((partner) => <EntityGroupDetailDropdownOptionModel>({
            value: {...partner, country: {...input.country}},
            titleTransform(): string {
                return `${this.value.code} - ${this.value.name}`;
            },
            viewModeTransform(): string {
                return `${this.value.code} - ${this.value.country.name}`;
            },
            // Using an accessor, so we have a function and "this" is scoped to the object we're mapping to.
            get tooltip(): string {
                return `${this.value.code} - ${this.value.name}`;
            },
            tooltipType: BaseChipSelectorZoneTooltipEnum.STATIC
        }));
    }

    static toCodeFilterModelArray(partners: PartnersGroupedByCountryModel[]): CodeFilterModel[] {
        return partners?.map((partnerGroup) => {
            const codeFilter = {
                name: partnerGroup.country.name,
                code: partnerGroup.country.alpha2Code,
                active: partnerGroup.country.active,
                children: [],
                checked: true
            } as CodeFilterModel;

            partnerGroup.partners.forEach((partner) => {
                codeFilter.children.push({
                    name: partner.name,
                    code: partner.code,
                    active: partner.active,
                    father: codeFilter,
                    checked: true
                } as CodeFilterModel);
            });

            return codeFilter;
        });
    }
}
